module.exports = __webpack_public_path__ + "static/telecom-086d1ac371c6c2ee99484954dc40cb95.jpg";